import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, Storage } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as moment from 'moment';

import { getOrderToken, reset } from 'app/entities/order/order.reducer';
import { getEntity } from 'app/entities/event/event.reducer';
import { convertToDisplay, convertToDisplayWithTime, convertToTime, convertToWeekday } from 'app/shared/util/date-utils';
import { localeToLangKey } from 'app/shared/util/locale-utils';
import { IRootState } from 'app/shared/reducers';
import OrderBreadCrumb from '../order-breadcrumb';
import { IEvent } from 'app/shared/model/event.model';
import { showTimer } from 'app/shared/util/toast-util';
import { isEventHasEnabledSessions } from '../order-shared';
import { IPricing } from 'app/shared/model/pricing.model';

export interface IDateSelectionProps extends StateProps, DispatchProps, RouteComponentProps<{ eventId: string }> {}

export interface IDateSelectionState {
  event: IEvent;
  sessionId: number;
}

export class DateSelection extends React.Component<IDateSelectionProps, IDateSelectionState> {
  state: IDateSelectionState = {
    event: { descriptionCht: '', descriptionEng: '', sessions: [], pricings: [], site: { name: '' }, imageUrl: '' },
    sessionId: 0
  };

  constructor(props) {
    super(props);
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
  }

  componentDidMount() {
    if (this.props.match.params.eventId) {
      // higher priority
      this.props.getEntity(this.props.match.params.eventId);
    } else {
      const event = Storage.session.get('EVENT');
      if (event !== null) this.setState({ event });

      // if there is a cart, go to seat selection page directly
      const cart = Storage.session.get('CART');
      if (cart && cart.length > 0) this.props.history.push('/order/seat-selection');
    }
  }

  componentDidUpdate(prevProps) {
    const orderToken = Storage.session.get('ORDER_TOKEN');
    if (this.props.updateSuccess && prevProps.updateSuccess !== this.props.updateSuccess && orderToken != null) {
      showTimer(orderToken, this.props.history);
      this.props.history.push('/order/seat-selection');
    }
    if (this.props.event && this.props.event !== prevProps.event) {
      this.setState({ event: this.props.event });
      Storage.session.set('EVENT', this.props.event);
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  onRadioBtnClick(session) {
    Storage.session.set('SESSION', session);
    this.setState({ sessionId: session.id });
  }

  onNextStepBtnClick() {
    const orderToken = Storage.session.get('ORDER_TOKEN');
    const now = moment().unix() * 1000; // timestamp in seconds while validUntil in miili-seconds
    if (orderToken == null || now > orderToken.validUntil) {
      this.props.getOrderToken(this.props.history);
    } else {
      this.props.history.push('/order/seat-selection');
    }
  }

  render() {
    const { event } = this.state;

    // get unique pricing
    const pricings: IPricing[] = [];
    event.pricings.forEach(p => {
      if (!pricings.find(pricing => pricing.id === p.id)) {
        pricings.push(p);
      }
    });

    const sessionButtons = event.sessions.map(s => (
      <Button key={s.id} color="secondary" size="lg m-2" onClick={() => this.onRadioBtnClick(s)} active={this.state.sessionId === s.id}>
        {this.state.sessionId === s.id ? <FontAwesomeIcon icon="check" /> : ''} {convertToDisplayWithTime(s.startTime)}
      </Button>
    ));

    const isNextButtonDisabled = () => this.state.sessionId === 0;

    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <OrderBreadCrumb step="1" currentLocale={this.props.currentLocale} />
          <Row className="justify-content-center mr-4 ml-4">
            {/* Poster is landscape
          <Col md="12" className="text-center">
            {event.imageUrl ? <img src={event.imageUrl} width="100%" className="img-fluid"/> : <img src="/poster/default.jpg" width="100%" className="img-fluid"/>}
          </Col>
          <Col md="7">
            <p>{event.description}</p>
          </Col>
          */}
            {/* Poster is protrait*/}
            <Col md="4" className="text-center">
              {event.imageUrl ? (
                <img src={event.imageUrl} width="100%" className="img-fluid" />
              ) : (
                <img src="/poster/default.jpg" width="100%" className="img-fluid" />
              )}
            </Col>
            <Col md="4">
              <p className="fs-large" dangerouslySetInnerHTML={{ __html: event['detail' + localeToLangKey(this.props.currentLocale)] }} />
            </Col>
            <Col md="4">
              <div className="bg-light p-3">
                <p>
                  <FontAwesomeIcon icon="calendar-alt" className="icon icon-min-width" />
                  <Translate contentKey="order.dateselection.date">日期</Translate>
                  <br />
                  {event.sessions.map((s, i) => (
                    <>
                      {convertToDisplay(s.startTime)}({convertToWeekday(s.startTime)})<br />
                    </>
                  ))}
                </p>
                <p>
                  <FontAwesomeIcon icon="clock" className="icon icon-min-width" />
                  <Translate contentKey="order.dateselection.time">時間</Translate>
                  <br />
                  {event.sessions.length > 0 ? convertToTime(event.sessions[0].startTime) : ''}
                </p>
                <p>
                  <FontAwesomeIcon icon="ticket-alt" className="icon icon-min-width" />
                  <Translate contentKey="order.dateselection.price">門票價錢</Translate>
                  <br />
                  {pricings.map(
                    (pricing, i) =>
                      i + 1 !== pricings.length
                        ? 'HKD' + pricing.price + (pricing.remark ? pricing.remark : '') + ' / '
                        : 'HKD' + pricing.price + (pricing.remark ? pricing.remark : '')
                  )}
                  {event.pricings[0] && event.pricings[0].zone.freeSeating ? (
                    <Translate contentKey="order.dateselection.freeseating">Free Seating</Translate>
                  ) : (
                    ''
                  )}
                </p>
                <p>
                  <FontAwesomeIcon icon="map-marker-alt" className="icon icon-min-width" />
                  <Translate contentKey="order.dateselection.place">演出場館</Translate>
                  <br />
                  {event.site['name' + localeToLangKey(this.props.currentLocale)]}
                </p>
              </div>
            </Col>
          </Row>
          {isEventHasEnabledSessions(event) && (
            <Row className="justify-content-center mt-3 mb-3">
              <Col md="12" className="text-center bg-primary">
                <h2 className="mt-3 mb-3 text-light">
                  <Translate contentKey="order.dateselection.selection">請選擇場次</Translate>
                </h2>
              </Col>
              <Col md="12" className="text-center mt-3 mb-3">
                {sessionButtons}
              </Col>
              <Button color="primary" size="xlg" onClick={() => this.onNextStepBtnClick()} disabled={isNextButtonDisabled()}>
                <Translate contentKey="order.seatselectionnextstep">你正在排隊中，請按下一步</Translate>
              </Button>
            </Row>
          )}
          <Row className="justify-content-center">
            {event.seatingPlanUrl ? (
              <>
                <Col md="12" className="text-center bg-success">
                  <h2 className="mt-3 mb-3 text-light">
                    <Translate contentKey="order.dateselection.zonemap">Zone Map</Translate>
                  </h2>
                </Col>
                <Col md="12" className="text-center mt-3">
                  <img src={event.seatingPlanUrl} className="img-fluid" />
                </Col>
              </>
            ) : (
              <></>
            )}
            {event.locationUrl ? (
              <>
                <Col md="12" className="text-center bg-success">
                  <h2 className="mt-3 mb-3 text-light">
                    <Translate contentKey="order.dateselection.place">Place</Translate>
                  </h2>
                </Col>
                <Col md="12" className="text-center mt-3">
                  <img src={event.locationUrl} className="img-fluid" />
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
          <Row className="justify-content-center mt-3">
            <Col md="12" className="text-center bg-secondary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.dateselection.notes">購買須知</Translate>
              </h2>
            </Col>
            <Col md="10" className="mt-3">
              <p>
                一經PATO ENTERTAINMENT 成功訂購門票，即代表同意及接受 PATO ENTERTAINMENT 訂立的所有使用條款，
                請於訂購前細心閱讀以下條款。PATO ENTERTAINMENT 有權隨時更改任何條款。
              </p>
              <p dangerouslySetInnerHTML={{ __html: event['buyNotes' + localeToLangKey(this.props.currentLocale)] }} />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  loading: storeState.order.loading, // trigger render when loading > false after getOrderToken
  currentLocale: storeState.locale.currentLocale,
  updateSuccess: storeState.order.updateSuccess,
  event: storeState.event.entity
});

const mapDispatchToProps = { getOrderToken, reset, getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(DateSelection);
